import axios from './axios';

export const getWSToken = () => axios.get('/core/notifications/ws/tokens');
